
import html2canvas from 'html2canvas';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { Message } from 'element-ui';
let downLoading = false
function download(targetDoms,FileNameList) {
  if(downLoading){ return }
  if(!targetDoms || targetDoms.length == 0){ return }
  downLoading = true
  var arrImages = [];
  let options = { };
  for (let i = 0, len = targetDoms.length; i < len; i++) {
    html2canvas(targetDoms[i], options).then((canvas) => {
      let imgURL = canvas.toDataURL("image/png");
      arrImages.push({
        fileUrl: imgURL,
        renameFileName: FileNameList[i] + ".png",
      });
      if (i == len - 1) {
        filesToRar(arrImages, "司机注册二维码");
      }
    });
  }
}
async function filesToRar(arrImages, filename) {
  let zip = new JSZip();
  let cache = {};
  let promises = [];

  for (let item of arrImages) {
    const data = await getImgArrayBuffer(item.fileUrl)
    zip.file(item.renameFileName, data, { binary: true }); // 逐个添加文件
    cache[item.renameFileName] = data;
    promises.push(data);
  }
  setTimeout(() => {
    Promise.all(promises).then(() => {
      zip.generateAsync({ type: "blob" }).then((content) => {
        // 生成二进制流
        saveAs(content, filename); // 利用file-saver保存文件  自定义文件名
        downLoading = false
      });
    })
    .catch((res) => {
      Message.error("文件压缩失败");
      downLoading = false
    });
  }, 100);
}
//获取文件blob
function getImgArrayBuffer(url) {
  return new Promise((resolve, reject) => {
    //通过请求获取文件blob格式
    let xmlhttp = new XMLHttpRequest();
    xmlhttp.open("GET", url, true);
    xmlhttp.responseType = "blob";
    xmlhttp.onload = function () {
      if (this.status == 200) {
        resolve(this.response);
      } else {
        reject(this.status);
      }
    };
    xmlhttp.send();
  });
}

export {
  download
}